module.exports = __webpack_public_path__ + "static/media/ET.1101c373.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/ET.svg
// module id = 248
// module chunks = 0